import { CustomerState } from "./types";
import{ CustomerSchema } from "@/models/customer_schema";

export const getAllCustomers = (state: CustomerState): CustomerSchema[] => {
  return state.customers;
};

export const getSelected = (state: CustomerState): CustomerSchema => {
  return state.selected;
};

export const getCountries = (state: CustomerState): string[] => {
  // Get all unique countries
  const allCountries = state.customers
    .map(customer => customer.address.country)
    .filter((country, index, self) => 
      country && self.indexOf(country) === index
    );
  
  // Separate USA and Canada
  const mainCountries = ['USA', 'Canada'];
  const otherCountries = allCountries
    .filter(country => !mainCountries.includes(country))
    .sort();
  
  // Combine them (USA and Canada first, then others)
  return [...mainCountries, ...otherCountries];
};